import { Directive } from 'vue';

const formatCurrency = (value: number, locale = 'en-US', currency = 'USD'): string => {
    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(value);
};

const sanitizeValue = (value: string): string => {
    value = value.replace(/(?!^-)[^0-9.-]+/g, ''); // Solo números, '-' y '.'
    value = value.replace(/(?!^)-/g, ''); // '-' solo al inicio
    value = value.replace(/(\..*)\./g, '$1'); // Evitar múltiples puntos decimales

    if (value.includes('.')) {
        const parts = value.split('.');
        if (parts[1].length > 2) {
            return parts[0] + '.' + parts[1].slice(0, 1); // Limitar a 2 decimales
        }
    }
    return value;
};

export const vCurrency: Directive = {
    async mounted(el, binding) {
        const input = el.tagName === 'INPUT' ? el : el.querySelector('input');

        if (!input) {
            console.warn('vCurrency: No se encontró un input.');
            return;
        }

        const locale = binding.value?.locale || 'en-US';
        const currency = binding.value?.currency || 'USD';

        let rawValue = sanitizeValue(input.value || '0');

        const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));
        await delay(100);

        input.value = formatCurrency(parseFloat(rawValue) || 0, locale, currency);

        // input.addEventListener('focus', (event: any) => {
        // input.value = event.target.value;
        // input.value = formatCurrency(parseFloat(input.value) || 0, locale, currency);
        // });

        input.addEventListener('input', (event: any) => {
            const value = event.target.value;
            rawValue = sanitizeValue(value);
            input.value = rawValue;

            if (binding && binding.instance) {
                binding.instance.$emit('update:modelValue', rawValue);
            }
        });

        input.addEventListener('blur', (event: any) => {
            input.value = formatCurrency(parseFloat(event.target.value) || 0, locale, currency);
        });
    }
};
